import _ from 'lodash';
import React from 'react';
import { NavLink, navigateAction } from 'fluxible-router';
import styles from './index.sass';
import CustomerActions from '../../actions/CustomerActions';
import CustomerStore from '../../stores/CustomerStore';
import connectToStores from 'fluxible-addons-react/connectToStores';
import shallowCompare from '../../lib/shallowCompare';

class AcceptCookies extends React.Component {

  static contextTypes = {
    executeAction: React.PropTypes.func
  };

  constructor(props) {
    super(props);
  }

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  dismiss(e) {
    e.preventDefault();
    this.context.executeAction(CustomerActions.dismissCookies, {
      dismiss_cookies: true
    });
  }

  render() {
    if (this.props.dismissCookies) {
      return null;
    }

    return (
      <div className={styles.cookiePolicy}>
        <div className={styles.cookiePolicyText}>
          We use cookies for analytics and to improve our site. You agree to our use of cookies by closing this message box or continuing to use our site. To find out more, including how to change your settings, see our <NavLink className={styles.cookiePolicyLink} href={"https://delectable.com/cookiePolicy"}>Cookie Policy</NavLink>.
        </div>
        <div className={styles.cookiePolicyText}>
          <button className={styles.cookiePolicyLink} onClick={this.dismiss.bind(this)}>Dismiss</button>
        </div>
      </div>
    );
  }
}

AcceptCookies = connectToStores(AcceptCookies, [CustomerStore], (context, props) => {
  let customerStore = context.getStore(CustomerStore);
  return {
    dismissCookies: customerStore.getCookiesDismissed()
  };
});

export default AcceptCookies;


// WEBPACK FOOTER //
// banquet/components/AcceptCookies/index.js